import { Route } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { CheckoutApiService } from './services/checkout-api.service';
import { CheckoutService } from './services/checkout.service';
import { CheckoutState } from './state/checkout.state';

export const checkoutPageRouteConfig: Route = {
  path: 'checkout',
  loadComponent: () => import('./checkout-page.component').then((c) => c.CheckoutPageComponent),
  children: [
    {
      path: '',
      loadComponent: () =>
        import('./components/checkout-content/checkout-content.component').then((c) => c.CheckoutContentComponent),
      providers: [provideStates([CheckoutState]), CheckoutApiService, CheckoutService]
    },
    {
      path: 'reservation/:id',
      loadComponent: () =>
        import('./components/checkout-reservation-content/checkout-reservation-content.component').then(
          (c) => c.CheckoutReservationContentComponent
        ),
      // Reached as a deep link, so the state cannot be inherited from the sibling checkout route —
      // without these the selector reads an unmounted slice and throws before any error is reported.
      providers: [provideStates([CheckoutState]), CheckoutApiService]
    }
  ]
};
